import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
import { Container } from '../../comps/Container'
import React, { useEffect, useCallback } from 'react'
import { AepsButton } from '../../comps/AepsButton'
import { useNavigation } from '@react-navigation/native'
import { RouteProp, useRoute } from '@react-navigation/core'
import { Screens } from '../../nav/Screens'
import { BbpsStackParamList } from '../../nav/Bbps'
import { Image, ImageSourcePropType } from 'react-native'

type TransactionErrorRouteProp = RouteProp<BbpsStackParamList, typeof Screens.TRANSACTION_ERROR_DETAILS>

export const TransactionErrorDetails = () => {
  const navigation = useNavigation<any>()
  const route = useRoute<TransactionErrorRouteProp>()
  const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')

  // const BBPSAssuredLogo: ImageSourcePropType = require('../../assets/icons/BbpsAssured.svg')

  const { orderId, errorMessage, billDetails } = route.params || {}

  const formatDate = (dateStr: string) => {
    if (!dateStr) return 'N/A'
    const date = new Date(dateStr)
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
  }

  const product = billDetails?.order?.product || {}
  const payment = billDetails?.order?.payment || {}
  const paymentId = billDetails?.order?.payment?.id
  const paymentAt = billDetails?.order?.payment?.paymentAt
  const formattedPaymentDate = formatDate(paymentAt)
  const amount = payment?.amountDetails?.netAmount || '0.00'
  const orderIdd = billDetails?.order?.id
  // const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')

  const BBPSAssuredLogo: ImageSourcePropType = require('../../assets/images/BAssuredpng.png')
  useEffect(() => {
    localStorage.removeItem('pending_order_value')
    sessionStorage.removeItem('pending_order_value')
  }, [])

  const onDonePress = () => {
    navigation.reset({
      index: 0,
      routes: [{ name: Screens.BBPS_HOME_SCREEN } as any],
    })
  }

  const onBackToHomeDashboard = useCallback(() => {
    navigation.navigate(Screens.BBPS_HOME_SCREEN as any)
  }, [navigation])

  return (
    <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
      <Box flex={1} justifyContent="space-between" height="100%">
        <Box>
          {/* 1. Header Section: Visual Status */}
          <Box>
            {/* Added a subtle circular container for the failure icon */}
            <Box backgroundColor="WHITE" borderRadius={50}>
              <Icon id={'STATUS_FAILED'} color="RED" size={40} />
            </Box>
            <SpacerNew size={16} />
            <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
              {'Bill Payment has Failed'}
            </TextNew>
          </Box>

          <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={20} />

          <Box
            marginBottom={20}
            customShadowStyle="shadowPrimary"
            backgroundColor="WHITE"
            padding={18}
            gap={14}
            borderRadius={16}
            borderWidth={1}
            borderColor="GREY_SEPARATOR">
            <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} marginBottom={10}>
              <TextNew fontSize={16} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
                {'Transaction Details'}
              </TextNew>
             <Image source={BBPSAssuredLogo} style={{ width: 60, height: 60, resizeMode: 'contain' }} />
              {/* <Icon id={'INFO'} color="BRAND_PRIMARY_ACTION" size={24} /> */}
            </Box>

            <DetailRow label="Biller" value={product?.name || 'Bill Payment'} />
            <DetailRow label="Order ID" value={orderId} />
            <DetailRow label="BBPS Transaction ID" value={paymentId} />
            <DetailRow label="Payment Date" value={formattedPaymentDate} />
          </Box>
{/* 
          <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={20} /> */}

          {/* 2. Transaction Summary Section */}
          {/* <Box width={'100%'} mb={20}>
            <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'} mb={8}>
              <TextNew fontSize={12} color="PRIMARY_GREY" fontWeight="500">
                {'Order ID'}
              </TextNew>
              <TextNew fontSize={12} color="BLACK" fontWeight="500">
                {orderId || 'N/A'}
              </TextNew>
            </Box>
            <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'} alignItems="center">
              <TextNew fontSize={22} color="BLACK" fontWeight="500">
                {'Status'}
              </TextNew>
              <Box backgroundColor="ALTO_DISABLED" paddingHorizontal={8} paddingVertical={2} borderRadius={4}>
                <TextNew fontSize={12} color="RED" fontWeight={'FONT_WEIGHT_BOLD'}>
                  {'FAILED'}
                </TextNew>
              </Box>
            </Box>
          </Box> */}

          <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

          {/* 3. Failure Reason Section */}
          <Box width={'100%'} flexDirection={'column'}>
            <Box
              marginTop={10}
              padding={16}
              backgroundColor="WHITE" // Changed to white for better contrast against background
              borderRadius={12}
              borderWidth={1}
              borderColor="BORDER_COLOR"
              flexDirection={'column'}
              customShadowStyle="shadowPrimary">
              <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
                <TextNew fontSize={12} color="PRIMARY_GREY" fontWeight="bold">
                  Technical failure:{' '}
                  {errorMessage ||
                    'The transaction could not be processed. If money was debited, it will be refunded shortly.'}
                </TextNew>
                <SpacerNew direction="horizontal" size={10} />
                <Image source={BBPSAssuredLogo} style={{ width: 60, height: 60, resizeMode: 'contain' }} />
              </Box>
            </Box>

            {/* 4. Support/Info Section */}
            <Box
              marginTop={20}
              marginBottom={8}
              flexDirection={'row'}
              alignItems="center"
              backgroundColor="ALTO_DISABLED"
              padding={12}
              borderRadius={8}>
              <TextNew fontSize={12} lineHeight={18} color="DARK_GREY" flex={1}>
                {
                  "The payment will reflect at biller's end after 2-3 working days if successful, otherwise refund will be initiated."
                }
              </TextNew>
              <SpacerNew direction="horizontal" size={10} />
              <Icon id={'INFO'} color="PRIMARY" size={18} />
            </Box>
          </Box>

          <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mt={15} />
        </Box>

        {/* 5. Footer Actions */}
        <Box align="center" width="100%" mt="auto">
          <Box width={'100%'} mb={6}>
            <AepsButton onPress={onBackToHomeDashboard} title={'Done'} disabled={false} />
          </Box>
          
          <Box flexDirection="row" align="center" justify="center" mb={2}>
            <TextNew fontSize={12} color="TINY_GREY" fontWeight="500">
              Powered by
            </TextNew>
            <SpacerNew direction="horizontal" size={8} />
            <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
          </Box>
        </Box>
      </Box>
    </Container>
  )
}

const DetailRow = ({ label, value }: { label: string; value: string | number }) => (
  <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'flex-start'}>
    <TextNew fontSize={13} color="BRAND_COLOR_GRAY_2" fontWeight={'500'} flex={1}>
      {label}
    </TextNew>
    <TextNew fontSize={13} color="BRAND_PURE_BLACK" fontWeight={'500'} flex={1.5} textAlign="right">
      {value}
    </TextNew>
  </Box>
)

// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useEffect, useCallback } from 'react'
// import { AepsButton } from '../../comps/AepsButton'
// import { useNavigation } from '@react-navigation/native'
// import { RouteProp, useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'
// import { BbpsStackParamList } from '../../nav/Bbps'
// import { Image, ImageSourcePropType } from 'react-native'

// type TransactionErrorRouteProp = RouteProp<BbpsStackParamList, typeof Screens.TRANSACTION_ERROR_DETAILS>

// export const TransactionErrorDetails = () => {
//   const navigation = useNavigation<any>()
//   const route = useRoute<TransactionErrorRouteProp>()
//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
//   const { orderId, errorMessage, billDetails } = route.params || {}

//   const formatDate = (dateStr: string) => {
//     if (!dateStr) return 'N/A'
//     const date = new Date(dateStr)
//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true,
//     })
//   }

//   const product = billDetails?.order?.product
//   const payment = billDetails?.order?.payment
//   const paymentId = billDetails?.order?.payment?.id
//   const paymentAt = billDetails?.order?.payment?.paymentAt
//   const formattedPaymentDate = formatDate(paymentAt)
//   // const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
//   const amount = payment?.amountDetails?.netAmount || '0.00'

//   useEffect(() => {
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onDonePress = () => {
//     navigation.reset({
//       index: 0,
//       routes: [{ name: Screens.BBPS_HOME_SCREEN } as any],
//     })
//   }

//   return (
//     <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
//       <>
//         <Box flex={1} justifyContent="space-between">
//           <Box overflow={'auto'}>
//             <Box gap={15} mb={20}>
//               {/* Added a subtle circular container for the failure icon */}
//               <Box>
//                 <Icon id={'SUCCESSFUL_FILLED'} color="BRAND_PRIMARY_RED" size={30} />
//               </Box>
//               <SpacerNew size={16} />
//               <TextNew fontSize={24} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'} textAlign="center">
//                 {'Bill Payment has Failed'}
//               </TextNew>
//             </Box>

//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={20} />

//             {/* 2. Transaction Summary Section */}
//             <Box width={'100%'} mb={20}>
//               <Box flexDirection={'row'} justifyContent={'space-between'} mb={4}>
//                 <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1" fontWeight="500">
//                   {product?.name || 'BBPS Biller'}
//                 </TextNew>
//                 <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1">
//                   {'Amount'}
//                 </TextNew>
//               </Box>
//               <Box flexDirection={'row'} justifyContent={'space-between'} alignItems="center">
//                 <TextNew fontSize={20} color="BLACK" fontWeight="500">
//                   {product?.attribute?.authenticatorList?.[0] || 'N/A'}
//                 </TextNew>
//                 <TextNew fontSize={18} color="BLACK" fontWeight={'bold'}>
//                   ₹ {amount}
//                 </TextNew>
//               </Box>

//               {/* <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'} mb={8}>
//               <TextNew fontSize={12} color="PRIMARY_GREY" fontWeight="500">
//                 {'Order ID'}
//               </TextNew>
//               <TextNew fontSize={12} color="BLACK" fontWeight="500">
//                 {orderId || 'N/A'}
//               </TextNew>
//             </Box>
//             <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'} alignItems="center">
//               <TextNew fontSize={22} color="BLACK" fontWeight="500">
//                 {'Status'}
//               </TextNew>
//               <Box backgroundColor="ALTO_DISABLED" paddingHorizontal={8} paddingVertical={2} borderRadius={4}>
//                 <TextNew fontSize={12} color="RED" fontWeight={'FONT_WEIGHT_BOLD'}>
//                   {'FAILED'}
//                 </TextNew>
//               </Box>
//             </Box> */}
//             </Box>

//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mb={15} />

//             {/* 3. Failure Reason Section */}
//             <Box width={'100%'} flexDirection={'column'}>
//               <Box
//                 marginTop={10}
//                 padding={16}
//                 backgroundColor="WHITE" // Changed to white for better contrast against background
//                 borderRadius={12}
//                 borderWidth={1}
//                 borderColor="BORDER_COLOR"
//                 flexDirection={'row'}
//                 customShadowStyle="shadowPrimary">
//                 {/* <TextNew fontSize={12} color="PRIMARY_GREY" fontWeight="bold">
//                 Technical failure:
//               </TextNew> */}
//                 <TextNew fontSize={14} color="BLACK" fontWeight="500" lineHeight={20}>
//                   Technical failure:{' '}
//                   {errorMessage ||
//                     'The transaction could not be processed. If money was debited, it will be refunded shortly.'}
//                 </TextNew>
//                 <Icon id={'TIMER'} color="BRAND_COLOR_GRAY_1" size={16} />
//               </Box>

//               {/* 4. Support/Info Section */}
//               <Box
//                 marginTop={20}
//                 marginBottom={8}
//                 flexDirection={'row'}
//                 alignItems="center"
//                 backgroundColor="ALTO_DISABLED"
//                 padding={12}
//                 borderRadius={8}>
//                 <Icon id={'INFO'} color="PRIMARY" size={18} />
//                 <SpacerNew direction="horizontal" size={10} />
//                 <TextNew fontSize={12} lineHeight={18} color="DARK_GREY" flex={1}>
//                   {
//                     "The payment will reflect at biller's end after 2-3 working days if successful, otherwise refund will be initiated."
//                   }
//                 </TextNew>
//               </Box>
//             </Box>

//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'SEPERATOR'} width={'100%'} mt={15} />
//           </Box>

//           {/* 5. Footer Actions */}
//           <Box align="center" width="100%" mt="auto">
//             <Box width={'100%'} mb={20}>
//               <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
//             </Box>
//             <Box flexDirection="row" align="center" justify="center" mb={12}>
//               <TextNew fontSize={12} color="TINY_GREY" fontWeight="500">
//                 Powered by
//               </TextNew>
//               <SpacerNew direction="horizontal" size={8} />
//               <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
//             </Box>
//           </Box>
//         </Box>
//       </>
//     </Container>
//   )
// }

// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useState, useEffect, useCallback } from 'react'
// import { InactivityDialog } from '../../comps/InactivityDialog'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { ServiceHighlights } from '../../comps/ServiceHighlight'
// import { IconWithText } from '../../comps/IconWithText'
// import { AepsCheckBox } from '../../comps/AepsCheckBox'
// import { AepsButton } from '../../comps/AepsButton'
// import { flex } from 'styled-system'
// import { RowItem } from '../../comps/RowItem'
// import { useNavigation } from '@react-navigation/native'
// import { RouteProp, useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'
// import { BbpsStackParamList } from '../../nav/Bbps'
// import { BackHandler, Platform, StyleSheet, View, Image, ImageSourcePropType } from 'react-native'

// type TransactionErrorRouteProp = RouteProp<BbpsStackParamList, typeof Screens.TRANSACTION_ERROR_DETAILS>

// export const TransactionErrorDetails = () => {
//      const navigation = useNavigation<any>()
//   // const navigation = useNavigation()
//   const route = useRoute<TransactionErrorRouteProp>()

//   //  const route = useRoute<any>() // Access route params

//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
//   // Extract real data passed from Polling/API logic
//   const { orderId, errorMessage, paymentData } = route.params || {}

//   const [activeTab, setActiveTab] = useState('payBills')
//   const [showInactivityDialog, setShowInactivityDialog] = useState(false)
//   const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
//   const [checked, setChecked] = useState(false)

//   useEffect(() => {
//     // Clear sensitive polling data from storage to prevent recovery loops
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onDonePress = () => {
//     navigation.reset({
//       index: 0,
//       routes: [{ name: Screens.BBPS_HOME_SCREEN } as any],
//     })
//   }

//   const onBackToHomeDashboard = useCallback(() => {
//       navigation.navigate(Screens.BBPS_HOME_SCREEN as any)
//     }, [navigation])

//   const searchList = (tnxId) => {
//     console.log(tnxId)
//   }

//   const handlePress = () => {
//     setShowInactivityDialog(true)
//     console.log('enter something here.')
//   }

//   return (
//     <Container showFooter={false} overflow="auto">
//       <>
//         <Box justifyContent={'space-between'} height={'90%'}>
//           <Box overflow={'auto'}>
//             <Box gap={15}>
//               <Box>
//                 <Icon id={'SUCCESSFUL_FILLED'} color="BRAND_PRIMARY_RED" size={30} />
//               </Box>
//               <TextNew fontSize={25} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                 {'Bill Payment has Failed'}
//               </TextNew>
//               <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//               {/* <Box width={'100%'}>
//                 <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {'Bank of Test- Fastag Test'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {'Amount'}
//                   </TextNew>
//                 </Box>
//                 <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                   <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                     {'TS21TR5456'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                     {'3000.000'}
//                   </TextNew>
//                 </Box>
//               </Box> */}

//               <Box width={'100%'}>
//                 <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {'Order ID'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {orderId || 'N/A'}
//                   </TextNew>
//                 </Box>
//                 <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                   <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                     {'Status'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                     {'FAILED'}
//                   </TextNew>
//                 </Box>
//               </Box>
//             </Box>

//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//             <Box width={'100%'} flexDirection={'column'} justifyContent={'space-between'}>
//               <Box
//                 marginTop={10}
//                 padding={15}
//                 backgroundColor="BRAND_PRIMARY_ACTION"
//                 borderRadius={8}
//                 flexDirection={'row'}>
//                 <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//                   Reason for failure:
//                 </TextNew>
//                 <TextNew fontSize={14} color="BLACK" fontWeight="500">
//                   {errorMessage ||
//                     'The transaction could not be processed. If money was debited, it will be refunded shortly.'}
//                 </TextNew>
//               </Box>
//               <Box marginTop={8} marginBottom={8} flexDirection={'row'} gap={40}>
//                 <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                   {"The payment will reflect at biller's end after 2-3 working day's"}
//                 </TextNew>
//                 <Icon id={'CHECKBOX_OUTLINE'} color="AVAILABLE_GREEN" size={16} />
//               </Box>
//             </Box>
//             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//           </Box>
//         </Box>

//         <Box mt="auto" mb={30} align="center" width="100%">
//           <Box width={'100%'}>
//             <AepsButton onPress={onDonePress} title={'Done'} disabled={false} />
//           </Box>
//           <Box flexDirection="row" align="center" justify="center" mb={12}>
//             <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//               Powered by
//             </TextNew>
//             <SpacerNew direction="horizontal" size={8} />
//             <Image source={BBPSLogo} style={{ width: 80, height: 24, resizeMode: 'contain' }} />
//           </Box>
//         </Box>

//         {/* <Box width={'100%'}>
//                         <AepsButton
//                             onPress={onPrimaryButtonPress}
//                             title={'Register Now'}
//                             disabled={false}

//                         // iconId={status == 'LINKED' ? 'FINGERPRINT' : undefined}
//                         />
//                     </Box> */}
//       </>
//     </Container>
//   )

// return (
//   <Container showFooter={true} overflow="auto">
//     <Box justifyContent={'space-between'} height={'100%'}>
//       <Box>
//         {/* Header Section */}
//         <Box alignItems="center" gap={10} marginBottom={30}>
//           <Icon id={'SUCCESSFUL_FILLED'} color="BRAND_PRIMARY_RED" size={60} />
//           <TextNew fontSize={24} color="BLACK" fontWeight={'bold'} textAlign="center">
//             Bill Payment Failed
//           </TextNew>
//         </Box>

//         <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginBottom={20} />

//         {/* Details Section */}
//         <Box gap={15}>
//           <Box flexDirection={'row'} justifyContent={'space-between'}>
//             <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">Order ID</TextNew>
//             <TextNew fontSize={14} fontWeight="bold" color="BLACK">{orderId || 'N/A'}</TextNew>
//           </Box>

//           <Box flexDirection={'row'} justifyContent={'space-between'}>
//             <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">Status</TextNew>
//             <TextNew fontSize={14} color="BRAND_PRIMARY_RED" fontWeight="bold">FAILED</TextNew>
//           </Box>

//           {/* Error Message Box */}
//           <Box marginTop={10} padding={15} backgroundColor="BRAND_PRIMARY_ACTION" borderRadius={8}>
//             <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1" >
//               Reason for failure:
//             </TextNew>
//             <TextNew fontSize={14} color="BLACK" fontWeight="500">
//               {errorMessage || "The transaction could not be processed. If money was debited, it will be refunded shortly."}
//             </TextNew>
//           </Box>
//         </Box>

//         <SpacerNew />
//         <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />

//         <Box marginTop={20}>
//           <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1" textAlign="center" lineHeight={18}>
//             For any queries, please quote the Order ID mentioned above.
//             Refunds typically reflect in your account within 5-7 working days.
//           </TextNew>
//         </Box>
//       </Box>

//       {/* Footer Button */}
//       <Box width={'100%'} marginBottom={20}>
//         <AepsButton onPress={onDonePress} title={'Back to Home'} />
//       </Box>
//     </Box>
//   </Container>
// )
// }

// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useState, useEffect } from 'react'
// import { InactivityDialog } from '../../comps/InactivityDialog'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { ServiceHighlights } from '../../comps/ServiceHighlight'
// import { IconWithText } from '../../comps/IconWithText'
// import { AepsCheckBox } from '../../comps/AepsCheckBox'
// import { AepsButton } from '../../comps/AepsButton'
// import { flex } from 'styled-system'
// import { RowItem } from '../../comps/RowItem'
// import { useNavigation } from '@react-navigation/native'
// import { RouteProp, useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'
// import { BbpsStackParamList } from '../../nav/Bbps'

// type TransactionErrorRouteProp = RouteProp<BbpsStackParamList, typeof Screens.TRANSACTION_ERROR_DETAILS>

// export const TransactionErrorDetails = () => {
//   const navigation = useNavigation()
// //   const route = useRoute<TransactionErrorRouteProp>()
//   const route = useRoute<RouteProp<BbpsStackParamList, 'TRANSACTION_ERROR_DETAILS'>>()

//   // Access the verified types from your GenericTransactionErrorParams
//   // 1. Extract real data passed from the Polling logic
//   const { orderId, errorMessage } = route.params || {}

//   useEffect(() => {
//     // 2. Clear sensitive polling data from storage once we hit this terminal screen
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onDonePress = () => {
//     // Use reset to clear the navigation stack so the user can't "Go Back" to the error
//     navigation.reset({
//         index: 0,
//         routes: [
//             { name: Screens.BBPS_HOME_SCREEN } as any // Cast the whole object, not just the name
//         ],
//     });
//   }

//   const onPrimaryButtonPress = () => {
//     navigation.reset({
//       index: 0,
//       routes: [
//         { name: Screens.BBPS_HOME_SCREEN } as any, // Cast the whole object, not just the name
//       ],
//     })
//   }

//   const [activeTab, setActiveTab] = useState('payBills')
//   const [showInactivityDialog, setShowInactivityDialog] = useState(false)
//   const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
//   const [checked, setChecked] = useState(false)
//   const routes = useRoute()
//   const handleInactivityDialogPress = () => {
//     setShowInactivityDialog(false)
//   }

//   const searchList = (tnxId) => {
//     console.log(tnxId)
//   }

//   const handlePress = () => {
//     setShowInactivityDialog(true)
//     console.log('enter something here.')
//   }

//   return (
//     <Container showFooter={true} overflow="auto">
//       <>
//         <Box justifyContent={'space-between'} height={'100%'}>
//           <Box overflow={'auto'}>
//             <Box gap={15}>
//               <Box alignItems="center" gap={10}>
//                 <Icon id={'SUCCESSFUL_FILLED'} color="BRAND_PRIMARY_RED" size={60} />
//                 <TextNew fontSize={25} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                 {'Bill Payment has Failed'}
//               </TextNew>

//               </Box>

//               {/* Transaction Info */}
//               <Box gap={10}>
//                 <Box flexDirection={'row'} justifyContent={'space-between'}>
//                   <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
//                     Order ID
//                   </TextNew>
//                   <TextNew fontSize={14} fontWeight="bold">
//                     {orderId || 'N/A'}
//                   </TextNew>
//                 </Box>

//                 <Box flexDirection={'row'} justifyContent={'space-between'}>
//                   <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
//                     Status
//                   </TextNew>
//                   <TextNew fontSize={14} color="BRAND_PRIMARY_RED" fontWeight="bold">
//                     FAILED
//                   </TextNew>
//                 </Box>

//                 <Box marginTop={10} padding={12} backgroundColor="BRAND_PRIMARY_ACTION" borderRadius={8}>
//                   <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//                     Reason:
//                   </TextNew>
//                   <TextNew fontSize={14} color="BLACK">
//                     {errorMessage || "We couldn't process your request. Please try again later."}
//                   </TextNew>
//                 </Box>
//               </Box>

//               <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'BORDER_COLOR'} width={'100%'} />

//               <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1" textAlign="center">
//                 If any amount was debited, it will be refunded to your source account within 5-7 working days.
//               </TextNew>

//               <Box>
//                 <Icon id={'SUCCESSFUL_FILLED'} color="BRAND_PRIMARY_RED" size={30} />
//               </Box>
//               <TextNew fontSize={25} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                 {'Bill Payment has Failed'}
//               </TextNew>
//               <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//               <Box width={'100%'}>
//                 <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {'Bank of Test- Fastag Test'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                     {'Amount'}
//                   </TextNew>
//                 </Box>
//                 <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                   <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                     {'TS21TR5456'}
//                   </TextNew>
//                   <TextNew fontSize={12} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                     {'3000.000'}
//                   </TextNew>
//                 </Box>
//               </Box>
//               <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//               <Box marginTop={8} marginBottom={8} flexDirection={'row'} gap={40}>
//                 <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                   {"The payment will reflect at biller's end after 2-3 working day's"}
//                 </TextNew>
//                 <Icon id={'CHECKBOX_OUTLINE'} color="AVAILABLE_GREEN" size={16} />
//               </Box>
//               <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//             </Box>
//           </Box>
//           <Box width={'100%'} marginBottom={20}>
//             <AepsButton onPress={onDonePress} title={'Back to Home'} />
//           </Box>

//           {/* <Box width={'100%'}>
//                         <AepsButton
//                             onPress={onPrimaryButtonPress}
//                             title={'Register Now'}
//                             disabled={false}

//                         // iconId={status == 'LINKED' ? 'FINGERPRINT' : undefined}
//                         />
//                     </Box> */}
//         </Box>
//       </>
//     </Container>
//   )
// }

// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useState, useEffect } from 'react'
// import { InactivityDialog } from '../../comps/InactivityDialog'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { ServiceHighlights } from '../../comps/ServiceHighlight'
// import { IconWithText } from '../../comps/IconWithText'
// import { AepsCheckBox } from '../../comps/AepsCheckBox'
// import { AepsButton } from '../../comps/AepsButton'
// import { flex } from 'styled-system'
// import { RowItem } from '../../comps/RowItem'
// import { useNavigation } from '@react-navigation/native'
// import { RouteProp, useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'
// import { BbpsStackParamList } from '../../nav/Bbps'

// // Mock data and functions to simulate a dynamic component
// const useLazyApiData = (apiFn) => {
//     const [data, setData] = useState(null)
//     const [loading, setLoading] = useState(false)
//     const [error, setError] = useState(null)

//     const callApi = async () => {
//         setLoading(true)
//         setError(null)
//         try {
//             // Simulate an API call with a delay
//             const mockData = await new Promise(resolve => setTimeout(() => {
//                 // Mock data based on the section
//                 if (apiFn.name === 'fetchFavourites') {
//                     resolve([
//                         { id: '1', name: 'ICICI Bank FASTag', customerName: 'Prakash', vehicleNo: 'MH034589', lastLinked: 'O5 june 2025' },
//                         { id: '2', name: 'Airtel Postpaid', customerName: 'Rahul', mobileNo: '9876543210', lastLinked: '10 July 2025' }
//                     ])
//                 } else if (apiFn.name === 'fetchRecentPayments') {
//                     resolve([
//                         { id: '3', name: 'BSES Rajdhani', customerName: 'Anil', accountNo: '12345678', lastLinked: '22 May 2025' },
//                         { id: '4', name: 'JioFiber', customerName: 'Priya', accountNo: '87654321', lastLinked: '01 June 2025' }
//                     ])
//                 } else {
//                     resolve([])
//                 }
//             }, 1000))
//             setData(mockData)
//         } catch (err) {
//             setError(err)
//         } finally {
//             setLoading(false)
//         }
//     }

//     return [data, callApi, loading, error]
// }

// const mockFetchFavourites = () => { /* This function is just a placeholder to be used by the hook */ }
// const mockFetchRecentPayments = () => { /* This function is just a placeholder to be used by the hook */ }

// const staticData = [
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
// ]

// export const TransactionErrorDetails = () => {
//    const navigation = useNavigation()
//     const route = useRoute<RouteProp<BbpsStackParamList, 'TRANSACTION_ERROR_DETAILS'>>()

//     // Access the verified types from your GenericTransactionErrorParams
//     const { orderId, errorMessage } = route.params

//     const onPrimaryButtonPress = () => {
//     navigation.reset({
//         index: 0,
//         routes: [
//             { name: Screens.BBPS_HOME_SCREEN } as any // Cast the whole object, not just the name
//         ],
//     });
// };

//     const [favourites, fetchFavourites, favouritesLoading] = useLazyApiData(mockFetchFavourites)
//     const [recentPayments, fetchRecentPayments, paymentsLoading] = useLazyApiData(mockFetchRecentPayments)
//     const [activeTab, setActiveTab] = useState('payBills')
//     const [showInactivityDialog, setShowInactivityDialog] = useState(false);
//     const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
//     const [checked, setChecked] = useState(false)
//     const routes = useRoute()
//     const handleInactivityDialogPress = () => {
//         setShowInactivityDialog(false);
//     };

//     useEffect(() => {
//         // 2. Clear sensitive polling data from storage once we hit this terminal screen
//         localStorage.removeItem('pending_order_value');
//         sessionStorage.removeItem('pending_order_value');
//     }, [])

//     // useEffect(() => {
//     //     fetchFavourites()
//     //     fetchRecentPayments()
//     // }, [])

//     const searchList = (tnxId) => {
//         console.log(tnxId)
//     }

//     const handlePress = () => {
//         setShowInactivityDialog(true)
//         console.log("enter something here.")
//     }

//     return (
//         <Container showFooter={true} overflow='auto'>
//             <>
//                 <Box justifyContent={'space-between'} height={'100%'} >
//                     <Box overflow={'auto'}>
//                         <Box gap={15}>
//                             <Box>
//                                 <Icon id={'SUCCESSFUL_FILLED'} color="BRAND_PRIMARY_RED" size={30} />
//                             </Box>
//                             <TextNew fontSize={25} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                                 {"Bill Payment has Failed"}
//                             </TextNew>
//                             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//                             <Box width={'100%'}>
//                                 <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                                     <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                                         {"Bank of Test- Fastag Test"}
//                                     </TextNew>
//                                     <TextNew fontSize={12} lineHeight={28} color="BRAND_COLOR_GRAY_1">
//                                         {"Amount"}
//                                     </TextNew>
//                                 </Box>
//                                 <Box width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
//                                     <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                                         {"TS21TR5456"}
//                                     </TextNew>
//                                     <TextNew fontSize={12} lineHeight={28} color="BLACK" fontWeight={'bold'}>
//                                         {"3000.000"}
//                                     </TextNew>
//                                 </Box>
//                             </Box>
//                             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//                             <Box marginTop={8} marginBottom={8} flexDirection={'row'} gap={40}>
//                                 <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                                     {"The payment will reflect at biller's end after 2-3 working day's"}
//                                 </TextNew>
//                                 <Icon id={'CHECKBOX_OUTLINE'} color="AVAILABLE_GREEN" size={16} />
//                             </Box>
//                             <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//                         </Box>

//                     </Box>
//                     <Box width={'100%'}>
//                         <AepsButton
//                             onPress={onPrimaryButtonPress}
//                             title={'Done'}
//                             disabled={false}
//                         />
//                     </Box>
//                     {/* <Box width={'100%'}>
//                         <AepsButton
//                             onPress={onPrimaryButtonPress}
//                             title={'Register Now'}
//                             disabled={false}

//                         // iconId={status == 'LINKED' ? 'FINGERPRINT' : undefined}
//                         />
//                     </Box> */}
//                 </Box>
//             </>
//         </Container>
//     )
// }
